export const getOnlineTransactionDetailTextStyle = (theme) => ({
    whiteSpace: 'pre'
});